import CardHeader from "components/CardHeader";
import React from "react";
import {Card, CardBody} from "reactstrap";
import {useOfficeTranslation} from "i18n/OfficeTranslation";

interface Props {
    title: string;
    amount: number;
    timeSpan: string;
    percentage: number;
    trendUp?: boolean;
    subtitle?: any;
    icon?: string;
}

interface Actions {
}

const MoneyCard: React.FC<Props & Actions> = ({subtitle, trendUp, icon, title, amount, timeSpan, percentage}) => {
    const {hasProvider, intlLocale} = useOfficeTranslation();
    const iconName = icon?.split(" ").find(value => value.startsWith("mdi-")) ?? "mdi-currency-eur";
    return (
        <Card className="h-100 mb-0">
            <CardBody>
                <CardHeader title={title} icon={iconName} />
                <div className="border-bottom py-3">
                    <h4 className="mb-0">{hasProvider ? new Intl.NumberFormat(intlLocale, {
                        style: "currency",
                        currency: "EUR",
                    }).format(amount) : `€ ${amount.toFixed(2)}`}</h4>
                </div>
                <p className="text-muted pt-3 mb-0">
                    {subtitle}
                    {trendUp !== undefined &&
                        <>
                            <span
                                className={`badge badge-soft-${(trendUp ? "success" : "danger")} me-1`}>
                                {trendUp ?
                                    <i className="mdi mdi-arrow-up-bold me-1"></i>
                                    :
                                    <i className="mdi mdi-arrow-down-bold me-1"></i>
                                }
                                {percentage.toFixed(0)}%
                            </span> {timeSpan}
                        </>
                    }
                </p>
            </CardBody>
        </Card>
    );
}

export default MoneyCard;
